type CloseIconProps = {
  className?: string;
};

export default ({ className }: CloseIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 96 96" className={className}>
    <path fill="#fff" d="m65.474 21.6 8.936 8.684-44.68 43.414-8.937-8.683z" />
    <path fill="#fff" d="m74.41 65.016-8.937 8.683-44.68-43.415 8.936-8.683z" />
  </svg>
);
